import * as React from 'react';
import MainCard from 'ui-component/cards/MainCard';
import SideMenu from './Components/Sbi_Limit/SideMenu';

const SBI_Limit_layout=()=>{
return(
    <MainCard  sx={{height:'80vh',overflowX:'scroll'}}>
        <SideMenu />
    </MainCard>
)
}

export default SBI_Limit_layout